import * as React from "react";
import {Checkbox, Icon, SemanticCOLORS, SemanticICONS, Table} from "semantic-ui-react";
import Button from "../../../components/Button";
import DeleteButton from "../../../components/DeleteButton";
import {formatDate} from "../../../components/Table/dataHandler/Utils";
import {ENewsPriority, NewsDto} from "../../../services/Client";
import {
    DraggableProvided,
    DraggableStateSnapshot,
} from "react-beautiful-dnd";
import HATEOASClient from "../../../services/HATEOASClient";
import {CheckboxProps} from "semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox";
import i18next from "i18next";

interface INotesAndNewsRowProps {
    note: NewsDto;
    t: reactI18Next.TranslationFunction;
    provided: DraggableProvided;
    snapshot: DraggableStateSnapshot;
    canEdit: boolean;
    client: HATEOASClient;
    onDelete: () => void;
    onUpdate: () => void;
    onUpdateActive: (newsDto: NewsDto, active: boolean) => void;
}

interface INotesAndNewsRowState {
    contentOpen: boolean;
}

const getNewsPriorityCell = (priority: ENewsPriority | undefined, t: i18next.TranslationFunction) => {
    let priorityIconName: SemanticICONS = 'question circle';
    let priorityIconColor: SemanticCOLORS = 'orange';

    switch (priority) {
        case ENewsPriority.INFO:
            priorityIconName = 'info';
            priorityIconColor = 'blue';
            break;
        case ENewsPriority.HIGH:
            priorityIconName = 'exclamation';
            priorityIconColor = 'red';
            break;
        default:
            break;
    }

    return (
        <Table.Cell width='1' style={{color: priorityIconColor, fontWeight: 'bold'}}>
            <Icon name={priorityIconName} color={priorityIconColor} />
            {t('NOTES_AND_NEWS:' + priority)}
        </Table.Cell>
    );
};

class NotesAndNewsRow extends React.Component<INotesAndNewsRowProps, INotesAndNewsRowState> {
    constructor(props: INotesAndNewsRowProps) {
        super(props);
        this.state = {
            contentOpen: false,
        };
    }

    render() {
        const {
            note,
            t,
            provided,
            snapshot,
            canEdit,
            client,
            onDelete,
            onUpdate,
            onUpdateActive
        } = this.props;

        return (
            <tr
                key={note.sequence}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={{
                    userSelect: "none",
                    background: snapshot.isDragging ? "#880505bd" : "initial",
                    ...provided.draggableProps.style
                }}
            >
                <Table.Cell width='10' textAlign={'left'} className='notes-and-news-text-cell'>
                    <div>{note.title}</div>
                    <div onClick={() => this.setState({contentOpen: !this.state.contentOpen})}>
                        {this.state.contentOpen
                            ? note.content
                            : this.props.t("NOTES_AND_NEWS:CONTENT")
                        }
                        <div><Icon name={this.state.contentOpen ? "eye slash" : "eye"} size={"big"} /></div>
                    </div>
                </Table.Cell>
                {getNewsPriorityCell(note.priority, t)}
                <Table.Cell width='1'>
                    <Checkbox
                        disabled={!canEdit}
                        toggle={true}
                        checked={note.active}
                        onChange={(event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => onUpdateActive(note, !!data.checked)}
                    />
                </Table.Cell>
                <Table.Cell width='1'>
                    {note.metadata && note.metadata.createdTimestamp ? formatDate(note.metadata.createdTimestamp) : "-"}
                </Table.Cell>
                <Table.Cell width='1' style={{minWidth: 120}}>
                    {note.metadata && note.metadata.changedTimestamp && note.metadata.changedTimestamp !== note.metadata.createdTimestamp
                        ? formatDate(note.metadata.changedTimestamp) : "-"}
                </Table.Cell>
                <Table.Cell width='2'>
                    <div className='display--flex flex-direction--column justify-content--center'>
                        {client.PATCH_news(note).canExecute() &&
                            <Button
                                label={t("NOTES_AND_NEWS:UPDATE")}
                                labelPosition={"after"}
                                icon={"pencil"}
                                disabled={!canEdit}
                                onClick={onUpdate}
                            />
                        }
                        {client.DELETE_news(note).canExecute() &&
                            <DeleteButton
                                label={t("NOTES_AND_NEWS:DELETE")}
                                confirmLabel={t("GLOBAL:CONFIRM")}
                                disabled={!canEdit}
                                requireConfirmation={true}
                                onClick={onDelete}
                            />
                        }
                        {!client.PATCH_news(note).canExecute() && !client.DELETE_news(note).canExecute() &&
                            t('NOTES_AND_NEWS:NO_RIGHTS')
                        }
                    </div>
                </Table.Cell>
            </tr>
        );
    }
}

export default NotesAndNewsRow;



// WEBPACK FOOTER //
// ./src/views/AdminView/NotesAndNewsTab/NotesAndNewsRow.tsx